/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { OfficeRolePermissionTreeRestService, OfficeRoleRestService } from '@gh/builder-shared-data';
import { DictionaryService, getRouteParam, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { OfficeRolePermissionTree } from './office-role-permission-tree.model';
import { OfficeRoleTodoPermissions } from './office-role-todo-permission.model';

@Injectable()
export class OfficeRolePermissionsBusinessService implements InitViewService {
  officeRoleId: ID;

  constructor(private officeRoleRest: OfficeRoleRestService,
              private officeRolePermissionRest: OfficeRolePermissionTreeRestService,
              private dictionaryService: DictionaryService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      officeRole: this.officeRoleRest.get(getRouteParam(route, 'officeRoleId')),
    };
  }

  initGeneralTabView(route: ActivatedRouteSnapshot): any {
    return {
      permissionTree: this.getGeneralPermissions(getRouteParam(<ActivatedRouteSnapshot>route.parent, 'officeRoleId')),
    };
  }

  initSetupTabView(route: ActivatedRouteSnapshot): any {
    return {
      permissionTree: this.getSetupPermissions(getRouteParam(<ActivatedRouteSnapshot>route.parent, 'officeRoleId')),
    };
  }

  getGeneralPermissions(id: ID): Observable<OfficeRolePermissionTree> {
    return this.officeRolePermissionRest.getGeneralPermissions(id);
  }

  updateGeneralPermissions(tree: OfficeRolePermissionTree): Observable<OfficeRolePermissionTree> {
    return this.officeRolePermissionRest.updateGeneralPermissions(tree);
  }

  getSetupPermissions(id: ID): Observable<OfficeRolePermissionTree> {
    return this.officeRolePermissionRest.getSetupPermissions(id);
  }

  updateSetupPermissions(tree: OfficeRolePermissionTree): Observable<OfficeRolePermissionTree> {
    return this.officeRolePermissionRest.updateSetupPermissions(tree);
  }

  initTodoTabView(route: ActivatedRouteSnapshot): any {
    this.officeRoleId = getRouteParam(<ActivatedRouteSnapshot>route.parent, 'officeRoleId');

    return {
      permissions: this.getTodoPermissions(),
      permissionDictionary: this.dictionaryService.get('TODO_TYPES'),
      officeRoleId: this.officeRoleId,
    };
  }

  getTodoPermissions(): Observable<OfficeRoleTodoPermissions> {
    return this.officeRolePermissionRest.getTodoPermissions(this.officeRoleId);
  }

  saveTodoPermissions(permissions: OfficeRoleTodoPermissions): Observable<OfficeRoleTodoPermissions> {
    return this.officeRolePermissionRest.saveTodoPermissions(this.officeRoleId, permissions);
  }
}
